var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section'),_c('ul',_vm._l((_vm.posts),function(post){return _c('Card',{key:post.id,attrs:{"post":post}})}),1),_c('Pagination',{attrs:{"currentPage":parseInt(_vm.page),"totalPages":parseInt(_vm.totalPages)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }